import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/modal'
import Font from '@cred/react-font'
import actions from '@cred/react-modal/actions'
import { connect } from 'react-redux'
import styles from './styles.scss'

const MODAL_SUFFIX = '-modal',
  generateModalName = formName => `${formName}${MODAL_SUFFIX}`,
  FilterModal = ({ filterText, openModal, closeModal, formName, children }) => (
    <>
      <div
        className={`${styles['filter-banner']} ${styles.background}`}
        onClick={openModal}
      >
        <i className={`icon-filter ${styles['filter-icon']}`} />
        <Font
          element="strong"
          weight="semiBold"
          className={styles.filter}
        >
            Filters
        </Font>
        <Font element="span" color="neutral">
          {filterText}
        </Font>
      </div>
      <section className={styles.modal}>
        <Modal hideHeader withoutPadding dismiss name={generateModalName(formName)}>
          <Font className={styles.header} type="bodySmall" weight="bold">Filter</Font>
          <section className={styles.container}>{children({ closeModal })}</section>
        </Modal>
      </section>
    </>
  ),
  mapDispatchToProps = (dispatch, ownProps) => {
    const { formName } = ownProps,
      { openModal, closeModal } = actions,
      modalName = generateModalName(formName)
    return {
      openModal: () => dispatch(openModal(modalName)),
      closeModal: () => dispatch(closeModal(modalName)),
    }
  }

FilterModal.propTypes = {
  filterText: PropTypes.string,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  formName: PropTypes.string,
  children: PropTypes.func,
}

export { FilterModal as FilterModalNoHoc, mapDispatchToProps }

export default connect(
  null,
  mapDispatchToProps,
)(FilterModal)
